<template>
    <div>
        <div v-if="$mq !== 'sm'" id="diagram"></div>
        <div v-if="$mq === 'sm'" class="mt-5">
            <div v-for="(skill, index) in skills" v-bind:key="index">
                <h5>{{skill.text}}</h5>
                <b-progress :variant="skill.variant" :striped="'striped'" :animated="'animate'" height="1.5rem" :value="skill.value" show-progress :max="100" class="mb-3"></b-progress>
            </div>
        </div>
    </div>
</template>

<script>
    import * as Raphael from 'raphael';
    export default {
        name: "skillsDiagram",
        data(){
            return {
                r: null,
                rad: 73,
                defaultText: 'My Skills',
                speed: 250,
                skills: [
                    {
                        color: '#767CAF',
                        value: 95,
                        text: 'PHP',
                        stroke: 26,
                        variant: 'info'
                    },
                    {
                        color: '#569C4C',
                        value: 80,
                        text: 'JavaScript',
                        stroke: 26,
                        variant: 'success'
                    },
                    {
                        color: '#587F9F',
                        value: 90,
                        text: 'MySQL',
                        stroke: 26,
                        variant: 'primary'
                    },
                    {
                        color: '#1087BA',
                        value: 98,
                        text: 'WordPress',
                        stroke: 95,
                        variant: 'secondary'
                    },
                    {
                        color: '#7a7a7a',
                        value: 90,
                        text: 'Linux',
                        stroke: 26,
                        variant: 'dark'
                    },
                    {
                        color: '#E24D31',
                        value: 98,
                        text: 'HTML5\n& CSS3',
                        stroke: 26,
                        variant: 'danger'
                    },

                ]
            }
        },
        methods: {
            random(l, u){
                return Math.floor((Math.random()*(u-l+1))+l);
            },
            desktopChart(){
                this.r = Raphael('diagram', 600, 600);
                this.r.circle(300, 300, 85).attr({ stroke: 'none', fill: '#333333' });
                let title = this.r
                    .text(300, 300, this.defaultText)
                    .attr({
                        font: '20px sans-serif',
                        fill: '#fff'
                    }).toFront();

                this.r.customAttributes.arc = (value, color, rad) => {
                    let v = 3.6*value,
                        alpha = v === 360 ? 359.99 : v,
                        random = this.random(91, 240),
                        a = (random-alpha) * Math.PI/180,
                        b = random * Math.PI/180,
                        sx = 300 + rad * Math.cos(b),
                        sy = 300 - rad * Math.sin(b),
                        x = 300 + rad * Math.cos(a),
                        y = 300 - rad * Math.sin(a),
                        path = [['M', sx, sy], ['A', rad, rad, 0, +(alpha > 180), 1, x, y]];
                    return { path: path, stroke: color }
                };

                for(let index in this.skills){
                    let skill = this.skills[index];
                    let speed = 250;
                    this.rad += 30;
                    let z = this.r.path().attr({
                        arc: [
                            skill.value,
                            skill.color,
                            this.rad
                        ],
                        'stroke-width' : skill.stroke
                    });

                    let self = this;

                    z.mouseover( function() {
                        this.animate({ 'stroke-width': 40, opacity: .85 }, 1000, 'elastic');
                        if(Raphael.type !== 'VML') //solves IE problem
                            this.toFront();
                        title.stop().animate({ opacity: 0 }, speed, '>', function(){
                            this.attr({ text: skill.text + '\n' + skill.value + '%' }).animate({ opacity: 1 }, speed, '<');
                        });
                    } );

                    z.mouseout( function() {
                        this.stop().animate({ 'stroke-width': 26, opacity: 1 }, speed*4, 'elastic');
                        title.stop().animate({ opacity: 0 }, speed, '>', function(){
                            title.attr({ text: self.defaultText }).animate({ opacity: 1 }, speed, '<');
                        });
                    } )
                }
            }
        },
        mounted(){
            if ( this.$mq !== 'sm' ){
                this.desktopChart();
            }
        }
    }
</script>

<style scoped>
    #diagram {
        width:600px;
        height:600px;
        margin:0 auto;
    }
</style>